import Swiper from 'swiper';

import { classNames as recsClassNames } from '../constants/recommendations';
import RecommendationsSlider from '../components/RecommendationsSlider/recommendations-slider';

export const conditionallyRenderAttrs = (cond, attrs) =>
  cond
    ? attrs
        .map(
          attr =>
            `${attr.name}${
              typeof attr.value !== 'undefined' ? `="${attr.value}"` : ''
            }`
        )
        .join(' ')
    : '';

/**
 *
 * @param {string} [headline] - heading above recommendations slider
 * @param {object} [data] - recommendations response data
 * @param {string} [selector] - CSS selector to query document with
 * @param {number} [slidesPerView] - how many slides to show within the viewport
 * @param {number} [spaceBetween] - space between slides in pixels
 * @param {string} [style=''] - CSS style for recommendations slider wrapper
 */
export const renderRecommendations = (
  headline,
  data,
  selector,
  slidesPerView,
  spaceBetween,
  style = ''
) => {
  const selectorNode = document.querySelector(selector);
  const existingSliderNode = document.querySelector(
    `.${recsClassNames.SLIDER_CONTAINER}`
  );
  if (existingSliderNode === null && selectorNode) {
    const sliderOptions = {
      slidesPerView,
      spaceBetween,
      navigation: {
        prevEl: `.${recsClassNames.SLIDER_NAV_ARROW_LEFT}`,
        nextEl: `.${recsClassNames.SLIDER_NAV_ARROW_RIGHT}`
      }
    };
    selectorNode.insertAdjacentHTML(
      'beforeend',
      RecommendationsSlider({ headline, data, style })
    );
    new Swiper(`.${recsClassNames.SLIDER_CONTAINER}`, sliderOptions);
  } else {
    console.error(
      `Could not render recommendations slider since mounting element ${selector} is not in the DOM.`
    );
  }
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/functions/renderer.js
 **/